import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { TrPlayerMediaService } from '../../services/tr-player-media.service';

@Component({
    selector: 'tr-video-preview',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: `./tr-video-preview.component.html`,
    styleUrls: ['./tr-video-preview.component.scss'],
})
export class TrVideoPreviewComponent {

    @Input() public title: string;
    @Input() public description: string;
    @Input() public id: number;
    @Input() public active: boolean;
    @Input() public continuePoint: boolean;
    @Input() public set duration(value: string) {
        this.formattedDuration = this.mediaService.formatTime(value);
    }
    @Output() public onPreviewClick: EventEmitter<any> = new EventEmitter();

    public formattedDuration: string;
    private selected: boolean;

    constructor(
        private mediaService: TrPlayerMediaService,
    ) {}

    public onClickHandler(event: Event) {
        this.onPreviewClick.emit(this.id);
    }
}
